import React, { Fragment } from 'react';
import { bool, func, element } from 'prop-types';

function TeaserInfoWrapper({ isLink, onClick, children }) {
  return (
    <Fragment>
      {isLink && (
        <a href="#" onClick={onClick}>
          {children}
        </a>
      )}

      {!isLink && <Fragment>{children}</Fragment>}

      <style jsx>{`
        a {
          color: inherit;
        }
      `}</style>
    </Fragment>
  );
}

TeaserInfoWrapper.propTypes = {
  isLink: bool.isRequired,
  onClick: func,
  children: element.isRequired
};

TeaserInfoWrapper.defaultProps = {
  onClick: undefined
};

export default TeaserInfoWrapper;
